var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currencyCredit > 0)?_c('b-message',{attrs:{"type":"is-info"}},[_c('p',[_vm._v(" "+_vm._s(_vm.context)+" "),_c('strong',[_vm._v(_vm._s(_vm.$formatCurrency(_vm.currencyCredit, _vm.computedCurrency)))]),_vm._v(" account credit which we'll automatically consume against future transactions. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }